const RESPONSIVE_ROBOT = {
  RESPONSIVE_ROBOT_PAGE_TITLE: 'لیست',
  RESPONSIVE_ROBOT_ADD_FIELD_BTN: 'اضافه کردن فیلد جدید',
  RESPONSIVE_ROBOT_INPUT_QUESTION_PLACEHOLDER: 'سوال',
  RESPONSIVE_ROBOT_INPUT_RESPONSE_PLACEHOLDER: 'جواب',
  RESPONSIVE_ROBOT_INPUT_LINK_PLACEHOLDER: 'لینک را وارد کنید',
  RESPONSIVE_ROBOT_SELECT_BOX_TITLE: 'انتخاب دپارتمان',
  RESPONSIVE_ROBOT_ACTIVE: 'فعال',
  RESPONSIVE_ROBOT_INACTIVE: 'غیر فعال',
  RESPONSIVE_ROBOT_TABLE_TITLE_1: 'عنوان',
  RESPONSIVE_ROBOT_TABLE_TITLE_2: 'وضعیت',
  RESPONSIVE_ROBOT_TABLE_TITLE_3: 'عملیات',
  RESPONSIVE_ROBOT_TABLE_TITLE_4: 'دپارتمان',
  RESPONSIVE_ROBOT_TABLE_TITLE: ' عملیات برای ربات پاسخگویی تعریف شده است',
  RESPONSIVE_ROBOT_NEW_OPERATION_BUTTON: 'ایجاد عملیات جدید',
  RESPONSIVE_ROBOT_TABLE_BUTTON: 'لیست عملیات ها',
  RESPONSIVE_ROBOT_TABLE_EACH_ITEM_TITLE: 'مجموعه شماره ',
  RESPONSIVE_ROBOT_DELETE_MODAL: 'آیا از حذف عملیات انتخابی اطمینان دارید؟',
  RESPONSIVE_ROBOT_DELETE_MODAL_SUBMIT_BTN: 'تایید',
  RESPONSIVE_ROBOT_LIST_EMPTY: 'هیچ عملیاتی تعریف نشده است!',
  RESPONSIVE_ROBOT_FORM_SUBMIT: 'انتشار',
  RESPONSIVE_ROBOT_FORM_CANCEL: 'انصراف',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_TEXT: 'پاسخ نهایی',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_QUESTION: 'سوال',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_EVENT: 'ایونت',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_REDIRECT: 'لینک',
  RESPONSIVE_ROBOT_FORM_TITLE: 'چطور میتونم کمکتون کنم؟',
  RESPONSIVE_ROBOT_LEVEL_TITLE: 'مرحله 1',
  RESPONSIVE_ROBOT_ADD_NEW_FORM: 'ایجاد سوال جدید',
};

export default RESPONSIVE_ROBOT;
